import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import styled, { css } from 'styled-components';

const commonStyles = css`
  color: ${(props) =>
    props.color
      ? props.color
      : props.isDarkBackground
        ? props.$lightColor
        : props.$darkColor};
  cursor: pointer;
  transition: all 0.1s;
  font-weight: ${(props) => props.$weight};
  font-size: ${(props) => props.$size};
  line-height: ${(props) => props.$lineHeight};

  &:hover,
  &:focus {
    color: ${(props) =>
      props.colorHover
        ? props.colorHover
        : props.isDarkBackground
          ? props.$lightColorHover
          : props.$darkColorHover};
    font-weight: ${(props) => props.$weightHover};
    font-size: ${(props) => props.$sizeHover};
    line-height: ${(props) => props.$lineHeightHover};
  }

  &:active {
    color: ${(props) =>
      props.colorHover
        ? props.colorHover
        : props.isDarkBackground
          ? props.$lightColorHover
          : props.$darkColorHover};
    font-weight: ${(props) => props.$weightHover};
    font-size: ${(props) => props.$sizeHover};
    line-height: ${(props) => props.$lineHeightHover};
  }
`;

const StyledAnchorTextInternal = styled((props) => <Link {...props} />)`
  ${commonStyles}
`;

const StyledAnchorTextExternal = styled.a`
  ${commonStyles}
`;

const AnchorText = function (props) {
  const {
    type,
    to,
    href,
    children,
    classes,
    isDarkBackground,
    color,
    colorHover,
    weight,
    weightHover,
    size,
    sizeHover,
    lineHeight,
    lineHeightHover,
    sanity,
  } = props;

  const { colors } = sanity;

  const commonProps = {
    isDarkBackground,
    color,
    colorHover,
    $lightColor: colors?.accent?.light,
    $lightColorHover: colors?.accent?.lighter,
    $darkColor: colors?.accent?.dark,
    $darkColorHover: colors?.accent?.darker,
    $weight: weight,
    $weightHover: weightHover,
    $size: size,
    $sizeHover: sizeHover,
    $lineHeight: lineHeight,
    $lineHeightHover: lineHeightHover,
    className: classes,
    activeClassName: 'active',
    children,
  };

  if (type === 'external') {
    return (
      <StyledAnchorTextExternal
        href={href}
        target="_blank"
        rel="noopener"
        {...commonProps}
      />
    );
  }
  const link =
    to === 'home' || to === '/home' || to === '/home/' || to === '/'
      ? '/'
      : `/${to}/`;
  return <StyledAnchorTextInternal to={link} {...commonProps} />;
};

AnchorText.defaultProps = {
  type: 'internal',
  to: '/',
  classes: '',
  isDarkBackground: false,
  color: '',
  colorHover: '',
};

AnchorText.propTypes = {
  type: PropTypes.string,
  to: PropTypes.string,
  classes: PropTypes.string,
  children: PropTypes.node.isRequired,
  isDarkBackground: PropTypes.bool,
  color: PropTypes.string,
  colorHover: PropTypes.string,
  weight: PropTypes.string,
  weightHover: PropTypes.string,
  size: PropTypes.string,
  sizeHover: PropTypes.string,
  lineHeight: PropTypes.string,
  lineHeightHover: PropTypes.string,
  colors: PropTypes.object,
};

export { AnchorText };
